import { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { removeProductFromCart as apiRemoveProduct } from 'scripts/api/cart'

import { dataLayer } from 'reactSite/Cart/services'

import { useResize } from 'reactUtils/hooks/use-resize'

import Product from 'checkout/components/MiniCart/Product'

const Products = ({
  product,
  type,
  removeProductFromCart,
  updateProduct,
  services,
  availableServices,
  regionId
}) => {
  const [animationKeys, setAnimationKeys] = useState({
    hideProduct: false,
    animation: false,
    showDisclaimer: false,
    hideComponent: false
  })
  const [isMobile] = useResize()

  const removeProductAPI = useCallback(async (product) => {
    await apiRemoveProduct(product?.id)
      .then(({ status }) => {
        dataLayer.removeProduct(product)

        if (status === 204) {
          setAnimationKeys(keys => ({
            ...keys,
            animation: true
          }))

          setTimeout(() => {
            setAnimationKeys(keys => ({
              ...keys,
              hideProduct: true,
              animation: false,
              showDisclaimer: true
            }))
          }, 500)

          setTimeout(() => {
            setAnimationKeys(keys => ({
              ...keys,
              showDisclaimer: false,
              hideComponent: true
            }))

            removeProductFromCart({
              id: product?.id,
              updateTotal: true
            })
          }, 1500)
        }
      })
      .catch(err => console.log('Error =>', err))
  }, [removeProductFromCart])

  useEffect(() => {
    return () => {
      setAnimationKeys({
        hideProduct: false,
        animation: false,
        showDisclaimer: false,
        hideComponent: false
      })
    }
  }, [])

  if (animationKeys?.hideComponent) {
    return null
  }

  return (
    <Product
      animationKeys={animationKeys}
      key={product.id}
      isMobile={isMobile}
      product={{ ...product, type }}
      removeProduct={removeProductAPI}
      updateProduct={updateProduct}
      services={services}
      availableServices={availableServices}
      regionId={regionId}
    />
  )
}

Products.propTypes = {
  product: PropTypes.object,
  type: PropTypes.string,
  removeProductFromCart: PropTypes.func,
  updateProduct: PropTypes.func
}

Products.defaultProps = {
  removeProductFromCart: () => {},
  updateProduct: () => {}
}

export default Products
